var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }